"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("../../../utils/styles");

var _overrides = require("../../../utils/overrides");

var _Checkbox = _interopRequireDefault(require("../../general/Checkbox"));

var _styles2 = _interopRequireDefault(require("./styles"));

var useStyles = (0, _styles.createUseStyles)(_styles2.default, 'CheckboxControl');

function CheckboxControl(_ref) {
  var children = _ref.children,
      classesProp = _ref.classes,
      overridesProp = _ref.overrides,
      classNameProp = _ref.className,
      option = _ref.option,
      onChange = _ref.onChange,
      value = _ref.value,
      isReadOnly = _ref.isReadOnly,
      props = (0, _objectWithoutProperties2.default)(_ref, ["children", "classes", "overrides", "className", "option", "onChange", "value", "isReadOnly"]);
  var classes = (0, _overrides.useClasses)(useStyles, classesProp); // Overrides

  var override = (0, _overrides.getOverrides)(overridesProp, CheckboxControl.overrides);
  var onChangeCheckbox = (0, _react.useCallback)(function () {
    onChange && onChange(option.value);
  }, [onChange, option]);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    key: option.value,
    className: classes.checkboxControl,
    onClick: isReadOnly ? undefined : function () {
      return onChangeCheckbox(option.value);
    }
  }, override.checkboxControl), /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
    checked: value,
    isDisabled: isReadOnly
  }), /*#__PURE__*/_react.default.createElement("span", (0, _extends2.default)({
    className: classes.checkboxLabel
  }, override.checkboxLabel), option.label));
}

CheckboxControl.overrides = ['checkboxLabel', 'checkboxControl'];
CheckboxControl.defaultProps = {
  onChange: function onChange() {},
  value: false,
  option: {},
  isReadOnly: false
};
process.env.NODE_ENV !== "production" ? CheckboxControl.propTypes = {
  className: _propTypes.default.string,
  overrides: _propTypes.default.object,
  onChange: _propTypes.default.func,
  option: _propTypes.default.shape({
    label: _propTypes.default.string,
    value: _propTypes.default.string
  }),
  value: _propTypes.default.bool,
  isReadOnly: _propTypes.default.bool
} : void 0;

var _default = /*#__PURE__*/_react.default.memo(CheckboxControl);

exports.default = _default;